"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Kontakt i Wycena",
  description: "Skontaktuj się z nami, aby umówić bezpłatną wizję lokalną w Pszczynie. Przygotujemy dla Ciebie precyzyjną wycenę prac."
}, {
  title: "Diagnostyka Systemu",
  description: "Przeprowadzamy inspekcję kamerą termowizyjną, aby precyzyjnie zlokalizować zatory i zimne punkty w Twoich grzejnikach."
}, {
  title: "Płukanie i Czyszczenie",
  description: "Usuwamy osady i kamień metodą hydrodynamiczną, przywracając pełną drożność i wydajność całej instalacji grzewczej."
}, {
  title: "Kontrola i Oszczędności",
  description: "Weryfikujemy efekty, odpowietrzamy układ i optymalizujemy pracę kotła, co przekłada się na niższe rachunki za energię."
}];
export default function ProstaDrogaDoPysznegoObiadu() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="130676" id="jak-pracujemy" className="bg-background py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Jak pracujemy? 4 kroki do wydajnego ogrzewania.
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Nasz proces czyszczenia instalacji CO jest szybki, profesjonalny i w pełni przejrzysty. Zadbaj o ciepło w swoim domu przed sezonem.
          </p>
        </div>

        <div ref={ref} className={`relative transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="hidden lg:block absolute top-[64px] left-[12.5%] right-[12.5%] border-t-2 border-dashed border-primary/40 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {steps.map((step, i) => <div data-index={i} key={i} className="h-full">
                <Card className="h-full bg-card rounded-3xl border-none shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl flex flex-col items-center text-center pt-8 pb-8 px-6">
                  <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-6 shrink-0">
                    <span className="text-3xl font-bold text-primary">{i + 1}</span>
                  </div>
                  <CardHeader className="p-0 w-full mb-4">
                    <CardTitle className="text-xl font-semibold text-foreground text-center !w-[225px]">
                      {step.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="p-0 flex-grow">
                    <p className="text-muted-foreground text-base">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}